import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminSettings() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((res) => setSettings(res.data)).catch(() => {});
  }, []);

  const update = async (field, next, okMsg, offMsg) => {
    try {
      const res = await api.put("/admin/settings", { [field]: next });
      setSettings(res.data);
      toast.success(next ? okMsg : offMsg);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  const card = (key, title, stateText, on, onToggle, loading) => (
    <div
      data-testid={`admin-settings-card-${key}`}
      className="mb-6 flex flex-wrap items-center justify-between gap-4 bg-white border border-slate-200 p-5"
    >
      <div>
        <p className="text-sm font-medium text-slate-900">{title}</p>
        <p className="mt-1 text-xs font-light text-slate-500" data-testid={`admin-${key}-state`}>
          {loading ? "…" : stateText}
        </p>
      </div>
      <button
        data-testid={`admin-${key}-toggle`}
        onClick={onToggle}
        disabled={loading}
        className={`rounded-full px-5 py-2.5 text-sm font-medium transition-colors duration-300 ${
          on
            ? "bg-red-50 text-red-700 border border-red-200 hover:bg-red-100"
            : "bg-brand text-white hover:bg-brand-dark"
        } disabled:opacity-50`}
      >
        {on ? "Disattiva / Disable" : "Attiva / Enable"}
      </button>
    </div>
  );

  const contactOn = settings?.contact_form_enabled === true;
  const langOn = settings?.language_switch_enabled !== false;

  return (
    <div data-testid="admin-settings-panel">
      {card(
        "contact-form",
        "Modulo contatti / Contact form",
        contactOn
          ? "Attivo — i visitatori possono inviare messaggi / Visitors can send messages"
          : "Disattivato — i visitatori vedono telefono e indirizzo / Visitors see phone and address",
        contactOn,
        () => update("contact_form_enabled", !contactOn, "Modulo contatti attivato.", "Modulo contatti disattivato."),
        settings === null
      )}
      {card(
        "language-switch",
        "Cambio lingua IT/EN / Language switch",
        langOn
          ? "Attivo — i visitatori possono passare a English / Visitors can switch to English"
          : "Disattivato — il sito resta in italiano / Site stays in Italian",
        langOn,
        () => update("language_switch_enabled", !langOn, "Cambio lingua attivato.", "Cambio lingua disattivato: il sito resta in italiano."),
        settings === null
      )}
    </div>
  );
}
